/**
 * External dependencies
 */
import { createSelector } from 'reselect';
import { get, find, map, sortBy, reverse } from 'lodash';

/**
 * Internal dependencies
 */
import { getAllCoupons } from 'state/coupons/selectors';
import { getAllAddons } from 'state/addons/selectors';

export const getCurrentRetailerRentalId = (state) => get(state, ['currentRetailerRental', 'id']);

export const getCurrentRetailerRental = (state) => {
    // const id = getCurrentRetailerRentalId(state);

    // if (!id) {
    //     return null;
    // }
    return get(state, ['currentRetailerRental', 'items'], []);
};

export const getCurrentRetailerRentalSubscription = (state) => {
    // const id = getCurrentRetailerRentalId(state);

    // if (!id) {
    //     return null;
    // }
    return get(state, ['currentRetailerRental', 'subscription'], []);
};

export const requestingCurrentRetailerRental = (state) => get(state, ['currentRetailerRental', 'requesting'], false);

export const errorRequestingCurrentRetailerRental = (state) => get(state, ['currentRetailerRental', 'error'], false);

export const hasScheduledChanges = createSelector(
    getCurrentRetailerRentalSubscription,
    (currentRetailerRental) => {
        return get(currentRetailerRental, ['has_scheduled_changes'], false);
    },
);

export const getCurrentRetailerRentalPlanId = createSelector(
    getCurrentRetailerRentalSubscription,
    (currentRetailerRental) => {
        return get(currentRetailerRental, ['plan_id'], null);
    },
);